import * as wabt from '@tencent/tab_js_sdk';
import { getCookieAmend } from './cookie';

let hasInitTab = false;
const guid = getCookieAmend('guid') || '';
const getTabConfig = async (expName) => {
  if (!hasInitTab) {
    // 开启SDK日志，默认日志不打开
    wabt.setLogLevel(0);
    // 只能初始化一次
    const isSuccess = await wabt.init({
      appId: '5606', // 必须，TAB平台的业务ID
      guid, // 必须，用户身份ID，用来做分流标识
      expSetting: {
        isAutoReport: true,
      },
    });
    if (!isSuccess) return null;
    hasInitTab = true;
  }
  if (expName) {
    const expInfo = wabt.getExpInfoByLayerCode(expName);
    return expInfo;
  }
};

export { getTabConfig };
